@if (!isPlatformTopNavEnabled) {
<div class="padding-for-legacy-navbar"></div>
} @if (!isMaintenanceMode && !isStandaloneRoute) { @if (isAuthenticated && !isPlatformTopNavEnabled) {
<a360-navbar></a360-navbar>
} @if (isAuthenticated && isPlatformTopNavEnabled) {
<fto-top-nav-bar [theme]="isNightMode ? 'dark' : 'light'"></fto-top-nav-bar>
} @if (isPlatformTopNavEnabled && isAuthenticated) {
<top-sub-nav (showSubnav)="onShowSubnav()"></top-sub-nav>
} @if (isAuthenticated) {
<a360-notification
  [isPlatformTopNavEnabled]="isPlatformTopNavEnabled"
  [attr.id]="isPlatformTopNavEnabled ? 'notification-top-nav' : null"
></a360-notification>
} @if (!isPlatformTopNavEnabled && isAuthenticated) {
<a360-sidebar [class.collapsed]="!isSidebarOpen"> </a360-sidebar>
} @if (isAuthenticated && !isPlatformTopNavEnabled) {
<div class="mobile-bg" id="mobile-bg" [class.active]="isSidebarOpen" (click)="isSidebarOpen = false"></div>
}

<!-- Overlay for mobile subnav -->
@if (isPlatformTopNavEnabled && isAuthenticated && isSubNavFull && isMobileScreen) {
<div class="subnav-mobile-overlay" (keydown)="onOverlayClick()" (click)="onOverlayClick()"></div>
} @if (isPlatformTopNavEnabled && isAuthenticated) {
<a360-subnav [forceOpen]="isSubNavFull" (subnavClosed)="onSubnavClosed()" [class.subnav-collapsed]="isSubNavCollapsed">
</a360-subnav>
}

<!-- CDK-like overlay for program switcher -->
@if (isPlatformTopNavEnabled && isAuthenticated && showProgramSwitcher) {
<div
  class="cdk-overlay-backdrop program-switcher-overlay"
  (click)="hideProgramSwitcher()"
  tabindex="-1"
  aria-hidden="true"
></div>
} @if (isPlatformTopNavEnabled && isAuthenticated && showProgramSwitcher) {
<program-switcher [visible]="'true'"></program-switcher>
}

<div class="drop-up-bg" [class.active]="isDropupOpened"></div>

<main
  class="page-content"
  id="content"
  [ngClass]="{
    authenticated: isAuthenticated,
    'sidebar-offset': isAuthenticated && isSidebarOpen && !isPlatformTopNavEnabled,
    'platform-topnav-enabled': isPlatformTopNavEnabled
  }"
>
  <router-outlet></router-outlet>
</main>

} @if (isMaintenanceMode) {
<a360-maintenance-mode></a360-maintenance-mode>
} @if (isStandaloneRoute) {
<router-outlet></router-outlet>
}
